import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import Cookies from 'js-cookie';
import { environment } from 'environments/environment';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  ngOnInit() : void { }

  ngAfterContentInit() : void {
    console.log('app reloaded')
    $.ajaxSetup({
      xhrFields: {withCredentials: true},
      beforeSend: function(xhr, settings) {
              function getCookie(name) {
                return Cookies.get(name, {domain: environment.domain, path: environment.path});
              }
              console.log(settings.url)
              console.log(!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url)))
              // if (/192.168.1.3/g.test(settings.url) || /localhost/g.test(settings.url) || /olap.goldenfinancing.com/g.test(settings.url)) {
                  // Only send the token to relative URLs i.e. locally.
                  var crsfToken = getCookie('csrftoken')
                  if (crsfToken != undefined && crsfToken != null)
                    xhr.setRequestHeader("X-CSRFToken", crsfToken);
              // }
          
      },
      error: function (x, status, error) {
        if (x.status == 401) {
          Cookies.remove('isStaff', {domain: environment.domain, path: environment.path})
          Cookies.remove('csrftoken', {domain: environment.domain, path: environment.path})
          Cookies.remove('OLAP_UserGroup', {domain: environment.domain, path: environment.path})
          Cookies.remove('reviewId', {domain: environment.domain, path: environment.path})
          Cookies.remove('sessionid', {domain: environment.domain, path: environment.path})
          document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + environment.path + "; domain=" + environment.domain;
          document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + environment.path + "; domain=" + environment.domain;
          window.location.href = "/#pages/login#notloggedin";
        }
      }
    });
  }
 }



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/app.component.ts